import React, { useRef } from "react";
import { mergeKpiConfigs } from "../config";
import BackValue from "../SupportFiles/BackValue";
import KpiTitle from "../SupportFiles/KpiTitle";
import KpiPrefix from "../SupportFiles/KpiPrefix";
import KpiSuffix from "../SupportFiles/KpiSuffix";
import KpiValue from "../SupportFiles/KpiValue";
import KpiIcon from "../SupportFiles/KpiIcon";
import KpiDescription from "../SupportFiles/KpiDescription";
import createRipple from "../SupportFiles/RippleEffect";
import CircleLoader from "../../../Loading/CircleLoader";

const Option13 = ({
  title = "Title",
  titleConfig = {},
  //
  value,
  valueConfig = {},
  //
  prefix = "",
  prefixConfig = {},
  //
  suffix = "",
  suffixConfig = {},
  //
  backValue = "",
  backValueConfig = {},
  //
  icon = "",
  iconConfig = {},
  //
  description = "",
  descriptionConfig = {},
  //
  bgConfig = {},
  //
  layoutConfig = {},
  overlayConfig = {},
  onClick,
  //
  isLoading,
}) => {
  const layoutType = "option13";
  ({ bgConfig, layoutConfig, overlayConfig } = mergeKpiConfigs(layoutType, {
    bgConfig,
    layoutConfig,
    overlayConfig,
  }));
  const cardRef = useRef(null);
  const handleRippleClick = (e) => {
    if (typeof onClick !== "function") return;
    createRipple(e, cardRef);
    onClick(e);
  };
  return (
    <div
      ref={cardRef}
      className={`${bgConfig.className} ${onClick && !isLoading ? "cursor-pointer" : ""}`}
      onClick={handleRippleClick}
    >
      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center bg-white/50 backdrop-blur-sm">
          <CircleLoader size={20} />
        </div>
      )}
      {onClick && !isLoading && <div className={overlayConfig.className} />}
      <div className={layoutConfig.layoutClassName}>
        <div className={layoutConfig.titleClassName}>
          {icon !== "" && (
            <KpiIcon icon={icon} iconConfig={iconConfig} option={layoutType} />
          )}
          <KpiTitle
            title={title}
            titleConfig={titleConfig}
            option={layoutType}
          />
        </div>
        <div className={layoutConfig.valueClassName}>
          {prefix !== "" && (
            <KpiPrefix
              prefix={prefix}
              prefixConfig={prefixConfig}
              option={layoutType}
            />
          )}
          <KpiValue
            value={value}
            valueConfig={valueConfig}
            option={layoutType}
          />
          {suffix !== "" && (
            <KpiSuffix
              suffix={suffix}
              suffixConfig={suffixConfig}
              option={layoutType}
            />
          )}
          {backValue !== "" && (
            <BackValue
              backValue={backValue}
              value={value}
              backValueConfig={backValueConfig}
              option={layoutType}
            />
          )}
        </div>
        {description !== "" && (
          <div className={layoutConfig.descriptionClassName}>
            <KpiDescription
              description={description}
              descriptionConfig={descriptionConfig}
              option={layoutType}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Option13;
